import { call, cancel, put, select, delay } from 'redux-saga/effects';
import { SagaIterator } from '@redux-saga/types';
import { SubjectArea } from 'features/subjectArea/types';
import { getSubjectAreaPage } from './sagaUtils';
import { getCurrentSubjectId } from 'features/subjectPage/redux';
import {
	getCurrentSubjectNumericId,
	getSubjectAreaActiveExamLevel,
} from 'features/subjectsOverview/redux';
import {
	setCurrentSubjectIdSubjectArea,
	setSubjectAreaActiveExamLevel,
	setsubjectAreaLoading,
} from '../slice';
import { getSelectedSubjectAreaComparisons } from '../selectors';
import { changeComprisonsFlow } from './changeComparisonFlow';
import { getAppliedGradepoints } from 'features/app/redux/context';
import { setComparisonGradepoint } from '../attainmentProfile/slice';
import { attainmentProfileData } from './fetchAttainmentProfileData';

/**
 * Saga that handles setting subject area page context
 */
export function* subjectAreaContext(): SagaIterator<void> {
	//Current subject area page
	const subjectAreaPage: SubjectArea.SubjectAnalysisPages = yield call(getSubjectAreaPage);

	//Get the subject Page 'id' - this is a string name
	const subjectPageCurrentSubject = yield select(getCurrentSubjectId);

	//Use the subject page 'id' to get the numeric subject id for use in the subject area
	const subjectOverviewSubjectId = yield select(
		getCurrentSubjectNumericId(subjectPageCurrentSubject)
	);

	// Bail out early if the numeric subject id is not available yet.
	if (!subjectOverviewSubjectId) {
		yield cancel();
	}

	//Set Subject Area Loading
	yield put(setsubjectAreaLoading(true));

	//Get the subject page examlevel
	const currentSubjectActiveExamlevel = yield select(
		getSubjectAreaActiveExamLevel(subjectPageCurrentSubject)
	);

	//Get the applied subject area comparisons
	const subjectAreaComparisons = yield select(getSelectedSubjectAreaComparisons);

	//Update redux with the current active examlevel
	yield put(setSubjectAreaActiveExamLevel(currentSubjectActiveExamlevel));

	//Update redux with the current subject id (Numeric)
	yield put(setCurrentSubjectIdSubjectArea(subjectOverviewSubjectId));

	//Fetch applied Gradepoints
	const appliedGradepoints = yield select(getAppliedGradepoints);

	//format the value to add to comparison gp, if theres only one then set as undefined
	const valueToAdd =
		appliedGradepoints.length > 1
			? appliedGradepoints[appliedGradepoints.length - 2].name
			: undefined;

	//Set comparison Gradepoint
	yield put(setComparisonGradepoint(valueToAdd));

	//Fetch grid and chart data
	yield call(
		attainmentProfileData,
		subjectAreaPage,
		currentSubjectActiveExamlevel,
		subjectOverviewSubjectId
	);

	//If there are applied comparisons spawn saga
	if (subjectAreaComparisons.length > 0) {
		yield call(changeComprisonsFlow);
	}

	// Allow state to update
	yield delay(1000);

	// set loading to false
	yield put(setsubjectAreaLoading(false));
}
